import { Link } from 'react-router-dom';
import './home.css';
 
function HomePage() {
  return (
    <div className="homepage-container">
      <div className="grid">
        <Link to="/summarizer" className="grid-item">
          <h2>Text Summarizer</h2>
        </Link>
        <Link to="/document-qa" className="grid-item">
          <h2>Document QA</h2>
        </Link>
        <Link to="/otherpage" className="grid-item">
          <h2>Coming Soon ..</h2>
        </Link>
      </div>

    </div>
  );
}

export default HomePage;
